import { call, delay, race, take } from 'redux-saga/effects';
import { pingEvents, fetchFile } from '../services/events';

export const pingEventBeforeSubmitBatch = function*(eventId, token) {
    try {
        let eventSucces = true;
        let notFoundAttempts = 0;
        const MAX_NOT_FOUND_ATTEMPTS = 5; 

        do {
            try {
                const {
                    data: { event }
                } = yield call(pingEvents, eventId, token);

                notFoundAttempts = 0;

                switch (event.status) {
                    case 200:
                        eventSucces = false;
                        break;
                    case 202:
                        yield delay(5000);
                        break;
                    case 500:
                        eventSucces = false;
                       
                        throw {
                            response: { status: 500 },
                            message: { key: `check_if_the_file_is_correct` }
                        };
                    default:
                        yield delay(5000);
                }
            } catch (error) {
                
                if (error.response && error.response.status === 404) {
                    notFoundAttempts++;
                    
                    if (notFoundAttempts >= MAX_NOT_FOUND_ATTEMPTS) {
                        eventSucces = false; 
                        return true; 
                    }
                    
                    yield delay(5000);
                } else {
                    throw error;
                }
            }
        } while (eventSucces);

        return true;
    } catch (error) {
        throw error;
    }
};

export const pingEvent = function* (eventId, accessToken, action_ping_close = "NOT_ACTION") {
    try {

        let eventSucces = true;

        const { respClose_1 } = yield race({
            respDelay: delay(2000),
            respClose_1: take(action_ping_close),
        });

        if (respClose_1) {
            eventSucces = false;
            return { type: action_ping_close };
        }

        while (eventSucces) {

            const { respEvent: { data: { event } }, respClose_2 } = yield race({
                respEvent: yield call(pingEvents, eventId, accessToken),
                respClose_2: take(action_ping_close),
            });

            if (respClose_2) {
                eventSucces = false;
                return { type: action_ping_close };
            }

            switch (event.status) {
                case 200:
                    eventSucces = false;
                   
                    const downloadResult = yield call(fetchFile, event.log.result.file_name, accessToken);
               
                    break;
                case 500:
                    eventSucces = false;

                    // eslint-disable-next-line no-throw-literal
                    throw {
                        response: { status: 500 }
                    };
                default:

                    const { respClose_3 } = yield race({
                        respDelay: yield delay(5000),
                        respClose_3: take(action_ping_close),
                    });

                    if (respClose_3) {
                        eventSucces = false;
                        return { type: action_ping_close }
                    }
            }

        };

        return true;
    } catch (error) {
        throw error;
    }
};
